// actions.ts

export const ADD_COURSE = 'ADD_COURSE';
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB'; // New action type

interface Tab {
  id: number;
  name: string;
  order: string;
  status: number;
}

interface AddCourseAction {
  type: typeof ADD_COURSE;
  payload: Tab[]; // Change payload type to Tab[]
}

interface SetSelectedTabAction {
  type: typeof SET_SELECTED_TAB;
  payload: number; // Payload is the selected tab ID (number)
}

export type CourseActionTypes = AddCourseAction | SetSelectedTabAction;

export const addCourse = (courses: Tab[]): AddCourseAction => ({
  type: ADD_COURSE,
  payload: courses,
});

export const setSelectedTab = (tabId: number): SetSelectedTabAction => ({
  type: SET_SELECTED_TAB,
  payload: tabId,
});
